import {
  getDeliverySettingsEndpoints,
  IGetDeliverySettingsDTO,
  IGetDeliverySettingsResponse,
  IUpdateDeliverySettingsDTO,
  IUpdateDeliverySettingsResponse,
} from '@/models/deliverySettings.model';
import { httpClient, ApiResponse } from '@/utils';

class DeliverySettingsAPI {
  static getDeliverySettings({ channelId }: IGetDeliverySettingsDTO): ApiResponse<IGetDeliverySettingsResponse> {
    const { GET_DELIVERY_SETTINGS } = getDeliverySettingsEndpoints({ channelId });
    return httpClient.get<IGetDeliverySettingsResponse>(GET_DELIVERY_SETTINGS);
  }

  static updateDeliverySettings({
    channelId,
    ...data
  }: IUpdateDeliverySettingsDTO): ApiResponse<IUpdateDeliverySettingsResponse> {
    const { UPDATE_DELIVERY_SETTINGS } = getDeliverySettingsEndpoints({ channelId });
    return httpClient.patch<IUpdateDeliverySettingsResponse>(UPDATE_DELIVERY_SETTINGS, data);
  }
}

export default DeliverySettingsAPI;
